import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { Skeleton } from '@/components/ui';
import { useTopCategories } from '@/hooks/useCategories';
import { CategoryChip } from '@/components/category/CategoryChips';

/**
 * Home category strip: pinned Favorites chip followed by the top-level
 * categories in a horizontal scroll rail. Every chip links its category hub
 * (`/{cc}/{lang}/category/…`), the same URL as "Top categories"; the
 * `/search?categoryId=` URL is only kept for old links.
 */
export function CategoryRail() {
  const { items, loading } = useTopCategories();

  return (
    <div className="flex gap-2 overflow-x-auto scrollbar-none px-1 py-1">
      <Link
        to="/favorites"
        className="flex shrink-0 items-center gap-1.5 rounded-full border border-error/30 bg-error/10 px-3 py-1.5 text-sm font-semibold text-primary-strong transition-all duration-200 hover:bg-error/20"
      >
        <Heart size={14} />
        <span className="whitespace-nowrap">Favorites</span>
      </Link>

      {loading && items.length === 0
        ? Array.from({ length: 6 }, (_, i) => (
            <Skeleton key={i} className="h-9 w-28 shrink-0 rounded-full" />
          ))
        : items.map((category) => (
            <CategoryChip key={category.id} category={category} className="shrink-0" />
          ))}
    </div>
  );
}

export default CategoryRail;
